import { useState, useEffect } from 'react'
import { MapContainer, TileLayer, Polygon } from 'react-leaflet'
import ChangeView from '../components/ChangeView'
import { TrySpan } from '../components/StyledElements'
import { FileInput } from '../components/StyledElements'
import { StyledA } from '../components/StyledElements'
import LZString from 'lz-string'
import {
  getStrFromTrkpts,
  getTrkptsFromString,
} from '../assets/assets_functions'
import { RiRulerLine } from 'react-icons/ri'

import { PayPalScriptProvider } from '@paypal/react-paypal-js'
import ButtonWrapper from '../components/ButtonWrapper'
import LineDraw from '../components/LineDraw'

import { clone, cloneDeep } from 'lodash'

// import { compress } from 'lz-string'

const TestZip = () => {
  const [gpxFile, setGpxFile] = useState()
  const [tzipSessions, setTZipSessions] = useState(null)
  const [trkpts, setTrkpts] = useState(null)
  const [tzipSessionStep, setTZipSessionStep] = useState(-1)
  const [tzipProcess, setTZipProcess] = useState(-1)
  const [measureDist, setMeasureDist] = useState(false)

  const style = { layout: 'vertical' }
  const currency = 'EUR'
  const amount = '9.99'

  let a = { name: 'john', age: 23, city: { where: 'ici', nb: 43 } }
  let b = cloneDeep(a)
  console.log('a : ' + a.city.nb)
  console.log('b : ' + b.city.nb)
  b.city.nb = 72
  console.log('a : ' + a.city.nb)
  console.log('b : ' + b.city.nb)

  const handleLoadSessions = () => {
    const url = '/api/sessionWS/getAllSessionsWS'
    fetch(url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
    })
      .then((response) => {
        response.json().then((data) => {
          let temp_sessions = []
          data.forEach((session) => {
            temp_sessions.push(session._id)
          })
          setTZipSessions(temp_sessions)
        })
      })
      .catch((error) => {
        console.log('Error adding blob', error)
      })
  }

  const handleLoadTrkptsAndSaveTZip = () => {
    setTZipSessionStep(0)
    setTZipProcess(0)
  }

  useEffect(() => {
    if (tzipProcess <= 0) return
    setTZipSessionStep(tzipSessionStep + 1)
    setTZipProcess(0)
  }, [tzipProcess])

  useEffect(() => {
    if (tzipSessionStep < 0) return
    if (tzipSessionStep > tzipSessions.length - 1) return
    const tzipSessionId = tzipSessions[tzipSessionStep]
    const url = '/api/t2/getTrkptsForSession'
    const sessionId = tzipSessionId
    const data = { sessionId }

    fetch(url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then((response) => {
        response.json().then((data) => {
          // let myStr = ''
          // data[0].trkpts.forEach((trkpt) => {
          //   myStr =
          //     myStr +
          //     trkpt.lat +
          //     ',' +
          //     trkpt.lng +
          //     ',' +
          //     trkpt.timeU +
          //     ',' +
          //     trkpt.time +
          //     ',' +
          //     trkpt.ele +
          //     ',' +
          //     trkpt.speed +
          //     ',' +
          //     trkpt.excluded +
          //     '*'
          // })
          // myStr = myStr.substring(0, myStr.length - 1)
          // const base64Str = LZString.compressToUTF16(myStr)
          const base64Str = getStrFromTrkpts(data[0].trkpts)
          const url = '/api/tzip/createTZip'
          const my_data = JSON.stringify({
            trkpts: base64Str,
            sessionId: tzipSessionId,
          })
          fetch(url, {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: my_data,
          })
            .then((response) => {
              response.json().then((data) => {
                setTZipProcess(1)
              })
            })
            .catch((error) => {
              console.log('Error adding tzip', error)
            })
        })
      })
      .catch((error) => {
        console.log('Error getting trkpts for session ' + tzipSessionId, error)
      })
  }, [tzipSessionStep])

  useEffect(() => {
    if (!gpxFile) return
    let reader = new FileReader()

    reader.readAsBinaryString(gpxFile)
    reader.onload = () => {
      const binaryStr = reader.result
      console.log(binaryStr.length)
      const base64Str = LZString.compressToUTF16(binaryStr)
      console.log(base64Str.length)
      const url = '/api/testzip/createZip'
      const my_data = JSON.stringify({ brand: base64Str })
      fetch(url, {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: my_data,
      })
        .then((response) => {
          response.json().then((data) => {
            const temp_session = data
            console.log(data)
          })
        })
        .catch((error) => {
          console.log('Error adding blob', error)
        })
    }
  }, [gpxFile])

  const handle_gpx_file = (event) => {
    const selected_gpx_file = event.target.files[0]
    setGpxFile(selected_gpx_file)
  }

  const handleLoad = () => {
    const url = '/api/testzip/loadZips'
    fetch(url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
    })
      .then((response) => {
        response.json().then((data) => {
          const temp_zips = data
          const my_zip = data[0].brand

          const myFinalStr = LZString.decompressFromUTF16(data[0].brand)
        })
      })
      .catch((error) => {
        console.log('Error adding blob', error)
      })
  }

  const handleTest = () => {
    // let myStr = ''
    // trkptsWS.brut.forEach((trkpt) => {
    //   myStr =
    //     myStr +
    //     trkpt.lat +
    //     ',' +
    //     trkpt.lng +
    //     ',' +
    //     trkpt.timeU +
    //     ',' +
    //     trkpt.time +
    //     ',' +
    //     trkpt.ele +
    //     ',' +
    //     trkpt.speed +
    //     ',' +
    //     trkpt.excluded +
    //     '*'
    // })
    // const compressedBinaryStr = LZString.compressToUTF16(myStr)
    // const url = '/api/testzip/createZip'
    // const my_data = JSON.stringify({ brand: compressedBinaryStr })
    // fetch(url, {
    //   method: 'post',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: my_data,
    // })
    //   .then((response) => {
    //     response.json().then((data) => {
    //       const temp_session = data
    //       console.log(data)
    //     })
    //   })
    //   .catch((error) => {
    //     console.log('Error adding blob', error)
    //   })
  }

  const handleMeasureDist = () => {
    setMeasureDist(!measureDist)
  }

  return (
    <>
      <div className="section">
        <div className="block">
          <div className="level">
            <div className="level-left">
              <div className="level-item">
                <button
                  className="button is-primary"
                  onClick={handleLoadSessions}
                >
                  Charger toutes les sessions
                </button>
              </div>
              <div className="level-item">
                <span className="is-primary">
                  {tzipSessions
                    ? tzipSessions.length + ' sessions chargées'
                    : 'aucune session chargée'}
                </span>
              </div>
            </div>
          </div>
          <div className="level">
            <div className="level-left">
              <div className="level-item">
                <button
                  className="button is-primary "
                  disabled={tzipSessions ? !tzipSessions.length > 0 : true}
                  onClick={handleLoadTrkptsAndSaveTZip}
                >
                  Convertir les trkpts en tzip
                </button>
              </div>
              <div className="level-item">
                <span className="is-primary">
                  {'En cours : ' +
                    (tzipSessionStep >= 0
                      ? 'session ' +
                        tzipSessionStep +
                        ' id : ' +
                        tzipSessions[tzipSessionStep]
                      : '')}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="block">
          <form encType="multipart/form-data">
            <TrySpan>Ajouter</TrySpan>
            <FileInput
              id="gpx_choose"
              type="file"
              onChange={handle_gpx_file}
              accept=".gpx"
            />
            <StyledA
              to="#"
              onClick={(e) => {
                document.getElementById('gpx_choose').click()
                e.preventDefault()
              }}
            >
              Upload GPX
            </StyledA>
          </form>
        </div>
        <div className="block">
          <button className="button is-primary" onClick={handleLoad}>
            Download GPX
          </button>
        </div>
        <div className="block">
          <button className="button is-primary" onClick={handleTest}>
            Test
          </button>
        </div>
      </div>
      <div style={{ maxWidth: '750px', minHeight: '200px' }}>
        <PayPalScriptProvider
          options={{
            'client-id':
              'AQ7LljUkKjogwZ8lE9SDGDXUhZsYTpOt-DKV5k7q3t-7XFS6Enb2y1XJevQ__veCPMmUpO2cIp7YNBt1',
            components: 'buttons',
            currency: 'USD',
          }}
        >
          <ButtonWrapper
            currency={currency}
            showSpinner={false}
            style={style}
            amount={amount}
          />
        </PayPalScriptProvider>
      </div>
      <div
        className="block mt-6 mb-6"
        style={{
          height: '700px',
          width: '1200px',
        }}
      >
        <MapContainer scrollWheelZoom={true} maxZoom={18} zoomOffset={-1}>
          <ChangeView
            center={[46.813, 6.302]}
            origin={'sessions'}
            map_bounds={null}
            map_path={null}
          />
          <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            zIndex="0"
          />
          {measureDist && <LineDraw />}
          <div
            className="container"
            style={{
              zIndex: '800',
              position: 'relative',
              top: '100px',
              left: '10px',
            }}
          >
            <button
              className="button"
              onClick={handleMeasureDist}
              title="Mesurer des distances"
            >
              <span
                className={
                  'icon is-large ' +
                  (measureDist === true
                    ? 'has-text-danger'
                    : 'has-text-primary')
                }
              >
                <RiRulerLine />
              </span>
            </button>
          </div>
        </MapContainer>
      </div>
    </>
  )
}

export default TestZip
